export const model = {
  id: null,
  name: '',
  region_id: null,  
  created_at: '',
  updated_at: '',
};
